module.exports = __webpack_public_path__ + "fonts/Raleway-Black.38b405eb.ttf";